/**
 * @author Gananath Athukorala
 * @version 0.1
 */

import React, { useEffect, useMemo, useState } from "react"
import { MaterialReactTable, useMaterialReactTable } from "material-react-table"
import api from "../../services/AuthApi"
import {
  Box,
  IconButton,
  LinearProgress,
  Tooltip,
  Paper,
  InputBase,
  Stack,
  Fab,
} from "@mui/material"
import { Check, HighlightOff } from "@mui/icons-material"
import ConfirmModal from "../../../toms/components/confirmRejectModals/ConfirmModal"
import RejectModal from "../../../toms/components/confirmRejectModals/RejectModal"
import { RequestErrorHandeling } from "../../errorHandeling/RequestErrorHandeling"
import Alerts from "../../errorHandeling/Alerts"
import SearchIcon from "@mui/icons-material/Search"
import RestartAltIcon from "@mui/icons-material/RestartAlt"

const PendingTable = ({
  isUpdate,
  setIsUpdate,
  pendRowCount,
  setPendRowCount,
}) => {
  const [pendData, setPendData] = useState([])
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [isPendRefetching, setIsPendRefetching] = useState(false)
  const [isDataChanged, setIsDataChanged] = useState(false)
  const [isSubmit, setIsSubmit] = useState(false)
  const [searchInput, setSearchInput] = useState()

  //table state
  const [globalFilter, setGlobalFilter] = useState("")
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  })

  //modals state
  const [confirmModelOpen, setConfirmModelOpen] = useState(false)
  const [rejectModalOpen, setRejectModalOpen] = useState(false)
  const [rowsData, setRowsData] = useState([])

  //for success messages
  const [isSuccess, setIsSuccess] = useState(false)
  const [successMessages, setSuccessMessages] = useState([])

  //for error handling
  const [iserror, setIserror] = useState(false)
  const [iserrorShow, setIserrorShow] = useState(false)
  const [isUnauhtError, setIsUnauhtError] = useState(false)
  const [errorMessages, setErrorMessages] = useState([])

  // Data loadingcto table
  let alertProps = {}
  if (isError) {
    alertProps = {
      color: "error",
      children: "Error loading data",
    }
  }

  // Pending User Accounts
  let getPendConfig = {
    headers: {
      "Sort-Order": "ASC",
      Action: "VAP",
    },
  }

  const fetchData = () => {
    api
      .get(
        "/users/" +
          pagination.pageIndex +
          "/" +
          pagination.pageSize +
          "/userId",
        getPendConfig
      )
      .then((res) => {
        setPendData(res.data?.dataList)
        setPendRowCount(res.data?.total)
        setIsLoading(false)
      })
      .catch((error) => {
        console.log(error)
      })

    setIsError(false)
    setIsPendRefetching(false)
  }

  useEffect(() => {
    fetchData()
  }, [pagination.pageIndex, pagination.pageSize, isUpdate, isUnauhtError])

  const handleClearData = () => {
    setIsSubmit(false)
    setConfirmModelOpen(false)
    setRejectModalOpen(false)
    setIsSubmit(false)
    setTimeout(() => {
      setIsSuccess(false)
      setSuccessMessages([""])
    }, 3000)
    setTimeout(() => {
      setIserror(false)
      setIserrorShow(false)
      setIsUnauhtError(false)
      setErrorMessages([])
    }, 10000)
  }

  let patchPendConfig = {
    headers: {
      "Content-Type": "application/json",
    },
  }
  const handleAccept = () => {
    setIsSubmit(true)
    setIsUpdate(false)
    const approvedIdList = rowsData?.map((row) => ({
      approvedId: row.approveId,
    }))

    const pendUser = {
      approvedIdList,
      rejectedIdList: [],
    }
    const appRow = JSON.stringify(pendUser)

    api
      .patch("/users", appRow, patchPendConfig)
      .then((res) => {
        setIsUpdate(true)
        setErrorMessages([])
        setIserror(false)
        setErrorMessages([])
        setIsUnauhtError(false)
        setIsSuccess(true)
        setSuccessMessages([res.data?.description])
        setIsDataChanged(!isDataChanged)
        setTimeout(() => {
          handleClearData()
        }, 3000)
      })
      .catch((error) => {
        setIsSuccess(false)
        RequestErrorHandeling(
          error,
          setIserror,
          setErrorMessages,
          setIserrorShow,
          setIsUnauhtError
        )
        setTimeout(() => {
          handleClearData()
        }, 3000)
      })

    setPendData([...pendData])
  }

  const handleReject = () => {
    setIsSubmit(true)
    setIsUpdate(false)
    const rejectedIdList = rowsData?.map((row) => ({
      rejectedId: row.approveId,
    }))
    const pendUser = {
      approvedIdList: [],
      rejectedIdList,
    }
    console.log("Reject", rejectedIdList)
    const appRow = JSON.stringify(pendUser)

    api
      .patch("/users", appRow, patchPendConfig)
      .then((res) => {
        setIsUpdate(true)
        setErrorMessages([])
        setIserror(false)
        setErrorMessages([])
        setIsUnauhtError(false)
        setIsSuccess(true)
        setSuccessMessages([res.data?.description])
        setIsDataChanged(!isDataChanged)
        setTimeout(() => {
          handleClearData()
        }, 3000)
      })
      .catch((error) => {
        setIsSuccess(false)
        RequestErrorHandeling(
          error,
          setIserror,
          setErrorMessages,
          setIserrorShow,
          setIsUnauhtError
        )
        setTimeout(() => {
          handleClearData()
        }, 3000)
      })

    setPendData([...pendData])
  }

  let userSearchConfig = {
    headers: {
      Action: "SEARCH_PEND_USERS",
      "Search-Key": searchInput,
      "Sort-Order": "ASC",
      "Sort-Field": "userId",
    },
  }

  const handleSearch = () => {
    setIsLoading(true)
    api
      .get("/users/search", userSearchConfig)
      .then((res) => {
        setPendData(res.data?.dataList)
        setIsLoading(false)
      })
      .catch((error) => {
        console.log(error)
      })
  }

  const handleSearchChange = (e) => {
    setSearchInput(e.target.value)
  }
  const handleResetFilter = () => {
    fetchData()
  }

  const columns = useMemo(
    () => [
      {
        accessorKey: "username",
        header: "Username",
        size: 50,
      },
      {
        accessorKey: "firstName",
        header: "First Name",
        size: 50,
      },
      {
        accessorKey: "lastName",
        header: "Last Name",
        size: 50,
      },
      {
        accessorKey: "primEmail",
        header: "Prim Email",
        size: 50,
      },
      {
        accessorKey: "primContact",
        header: "Prim Contact",
        size: 50,
      },
      {
        accessorKey: "userRole",
        header: "User Role",
        size: 50,
      },
    ],
    []
  )
  return (
    <div>
      <Box sx={{ width: "100%" }}>
        <div>
          <Alerts
            iserror={iserror}
            errorMessages={errorMessages}
            isSuccess={isSuccess}
            successMessages={successMessages}
            iserrorShow={iserrorShow}
          />
        </div>
        <Stack spacing={2} direction="row" sx={{ marginBottom: 2 }}>
          <Paper
            component="form"
            sx={{
              p: "2px 4px",
              display: "flex",
              alignItems: "center",
              width: 400,
            }}
          >
            <InputBase
              sx={{ ml: 1, flex: 1 }}
              placeholder="Search Users"
              inputProps={{ "aria-label": "search users" }}
              onChange={handleSearchChange}
            />
            <IconButton
              onClick={handleSearch}
              type="button"
              sx={{ p: "10px" }}
              aria-label="search"
            >
              <SearchIcon />
            </IconButton>
          </Paper>
          <Tooltip placement="right-end" title="Reset Filter">
            <Fab
              onClick={handleResetFilter}
              size="large"
              color="warning"
              variant="extended"
            >
              <RestartAltIcon />
            </Fab>
          </Tooltip>
        </Stack>
        <br />
        <MaterialReactTable
          enableColumnVirtualization
          columns={columns}
          data={pendData ?? []}
          positionActionsColumn="last"
          state={{
            globalFilter,
            isLoading,
            pagination,
            showProgressBars: isPendRefetching,
          }}
          getRowId={(row) => row.phoneNumber}
          manualPagination
          muiToolbarAlertBannerProps={alertProps}
          onGlobalFilterChange={setGlobalFilter}
          onPaginationChange={setPagination}
          rowCount={pendRowCount}
          muiTablePaginationProps={{
            rowsPerPageOptions: [10],
          }}
          editingMode="modal"
          enableColumnOrdering
          enableEditing
          enableColumnFilterModes
          enableRowSelection
          enableSelectAll
          renderRowActions={({ row }) => (
            <Box sx={{ display: "flex", gap: "1rem" }}>
              <Tooltip arrow placement="left" title="Accept">
                <IconButton
                  color="success"
                  onClick={() => {
                    setConfirmModelOpen(true)
                    setRowsData([row.original])
                  }}
                >
                  <Check />
                </IconButton>
              </Tooltip>
              <Tooltip arrow placement="right" title="Reject">
                <IconButton
                  color="error"
                  onClick={() => {
                    setRejectModalOpen(true)
                    setRowsData([row.original])
                  }}
                >
                  <HighlightOff />
                </IconButton>
              </Tooltip>
            </Box>
          )}
          renderTopToolbarCustomActions={({ table }) => {
            return (
              <div style={{ display: "flex", gap: "0.5rem" }}>
                <Box sx={{ display: "flex", gap: "1rem" }}>
                  <Tooltip arrow placement="left" title="Accept">
                    <IconButton
                      color="success"
                      disabled={!table.getSelectedRowModel().flatRows.length}
                      onClick={() => {
                        setRowsData([])
                        table.getSelectedRowModel().flatRows.forEach((row) => {
                          setRowsData((prevData) => [
                            ...prevData,
                            { ...row.original },
                          ])
                        })
                        setConfirmModelOpen(true)
                      }}
                      variant="contained"
                    >
                      <Check />
                    </IconButton>
                  </Tooltip>
                  <Tooltip arrow placement="right" title="Reject">
                    <IconButton
                      color="error"
                      disabled={!table.getSelectedRowModel().flatRows.length}
                      onClick={() => {
                        setRowsData([])
                        table.getSelectedRowModel().flatRows.forEach((row) => {
                          setRowsData((prevData) => [
                            ...prevData,
                            { ...row.original },
                          ])
                        })
                        setRejectModalOpen(true)
                      }}
                      variant="contained"
                    >
                      <HighlightOff />
                    </IconButton>
                  </Tooltip>
                </Box>
              </div>
            )
          }}
        />
      </Box>
      <ConfirmModal
        open={confirmModelOpen}
        isSubmit={isSubmit}
        handleAccept={handleAccept}
        onClose={() => {
          setConfirmModelOpen(false)
        }}
      />
      <RejectModal
        open={rejectModalOpen}
        isSubmit={isSubmit}
        handleReject={handleReject}
        onClose={() => {
          setRejectModalOpen(false)
        }}
      />
    </div>
  )
}

export default PendingTable
